import axios from "axios";

const BASE_URL = "https://youtube138.p.rapidapi.com";

const options = {
    url : BASE_URL ,
    params: {q: 'desp', hl: 'en', gl: 'US'},
    headers: {
      'X-RapidAPI-Key': 'a3f6be2d56mshcec3e0d18f31994p18e243jsn31a50217ae5e',
      'X-RapidAPI-Host': 'youtube138.p.rapidapi.com'
    }
};

export const fetchDataFromApi = async (url) => {
    const {data} = await axios.get(`${BASE_URL}/${url}` , options)
    return data;
}